import "./SharedComponents/sharedComponents.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import ConfigFile from "../../datasets/config_file";
import {Component} from 'react';
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';

class CarCard extends Component {
    photosArr = [];
   
    constructor(props) {
        super(props);
        this.toggleExpanded = this.toggleExpanded.bind(this);
        this.toggleSelected = this.toggleSelected.bind(this);
        this.state = {
            open: false, 
            selected: false,
            gameStartParms: ConfigFile.gameStartItems,
            carItems: ConfigFile.carItems,
        };
        this.addCostToFeatures();
    }

    addCostToFeatures(){
        const featuresList = JSON.parse(JSON.stringify(this.props.carInfo.features));
        this.featuresList = [];
        this.totalCost = this.props.carInfo.cost;
        for (let i=0; i<featuresList.length; i++){
              let feature = featuresList[i];
              if (feature.includes ("<<")){
                  const startPos = feature.indexOf("<<");
                  const endPos = feature.indexOf(">>");
                  const textString = feature.substring(startPos + 2, endPos);                 
                  feature = feature.substring(0,startPos);
                  if (this.state.gameStartParms[textString]){
                        let replaceValue = this.state.gameStartParms[textString];
                        if (this.props.bicycle.itemType === textString && this.props.bicycle.itemFound === true){
                            replaceValue = 0;
                            feature += " -  + $0 (already own)"
                        }else{
                            feature += " - " + doubleToStringMonthly(replaceValue);
                        }
                        this.totalCost += +replaceValue;
                  }
              }
              this.featuresList.push(feature);
        }
    }

    toggleExpanded(e) {
        this.setState({open: !this.state.open});
    }

    toggleSelected(e) {
        this.setState({selected: !this.state.selected});
        this.props.onSelected(this.props.carInfo.id);
    }

    render() {
        const featuresList = this.featuresList.map((feature, key) =>
        <li key={key}>{feature}</li>
        );
        const defaultImgSrc = './assets/' + this.props.carInfo.directory;
        var half_length = Math.ceil(featuresList.length / 2);    
        /* The following splice command removes the first half of entries from the includedlist array.
           After this splice command, IncludedList contains only the second half of the entries.  */
        var leftSide = featuresList.splice(0,half_length);  
        let featuresText = "Car Facts and Features:";
        let costLit = "Listed Cost:";        
        if (this.props.noCar === true){
            featuresText = "Package Includes:"
            costLit = "Package Cost: "
        }
              
    return <>
        <div className=
        {this.props.selectedAutomobileId === this.props.carInfo.id ?
            "card mx-3 my-2 link-tab-selected"
            :
            "card mx-3 my-2 drop-shadow"
        }
        >
        <div className="card-header text-left">
        
        <span className=" m-0 p-0">
            <span className="row w-100 mx-0" onClick={this.toggleExpanded}>
                    <div className="col-sm-4 p-0 text-left">
                            <img src={defaultImgSrc} className="home_card_thumbnail_img" alt="carImg"/>
                     </div>
                     <div className="col-sm-6 ml-3">
                            {!this.props.noCar   ?
                                <p className="mb-0 mt-4 font-weight-bold">{this.props.carInfo.ageName}</p>
                            :
                                null
                            }
                           <p className="mb-0 font-weight-bold">{costLit} 
                                {doubleToStringMonthly(this.totalCost)}</p>
                     </div>
                     <div className="col-sm-1 p-0 text-right">
                        {this.state.open ?
                            <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" />
                            :
                            <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" />
                        }
                     </div>   
                </span>
        </span>
        </div>
        {this.state.open ?
            <div className="card-body">
                <span className="container text-center m-0 p-0">
                    <h6 className="text-left">{featuresText}</h6>
                    <span className="row w-100 mx-0" onClick={this.toggleExpanded}>
                        <div className="col-sm-6 p-0 m-0">
                            <div className="text-left">
                                  <ul className="bulleted-list">{leftSide}</ul>
                             </div>
                        </div>
                        <div className="col-sm-6 p-0 m-0">
                            <div>
                                <div className="text-left">
                                     <ul className="bulleted-list">{featuresList}</ul>
                                </div>
                            </div>    
                        </div>
                    </span>
                </span>
                
                <span className="container text-right p-0">
                    <div className="ml-2">
                        <button className="btn btn-primary" onClick={this.toggleSelected}>
                            Select
                        </button>
                    </div>                         
                </span>
                
            </div>
        : <span/>
        }
        </div>
    </>
    }
}

export default CarCard;